export default __webpack_public_path__ + "static/media/earth_illustration.a0463adc.gif";